export enum LOCAL_STORAGE_KEY {
    AUTH_KEY = 'auth-key',
    LOGGED_IN_USER_ID = 'logged-in-user-id',
    SHOW_COMPLETED_EVENTS = 'show-completed-events',
    IS_EVENT_SIDEBAR_COLLAPSED = 'is-event-sidebar-collapsed',
    EVENTS_ROUTE_MODE = 'events-route-mode',
}
